module.exports = __webpack_public_path__ + "static/img/t4.98c2af3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/technology/t4.jpg
// module id = tgkf
// module chunks = 0